import { dispatchSirenActions } from "../Siren";
import { triggerSet } from "../Component";
import { WEBUILogs } from "@tinqin/tinqin-utils/src/logging";

// Creates google map marker
// the code for the click event listener and info window popup is in the component.
// The method is called after the returned from the 'loadGoogleMap' promise has been resolved.
export function createMapMarker(results, params) {
    let popoverContent = "";
    let locationOnMapsLink = "";
    let showLocationOnMapsLink = params.showLocationOnMapsLink;
    let location = params.location;
    let markerActionProps = params.markerActionProps;
    let widgetId = markerActionProps.widgetId;

    if (showLocationOnMapsLink) {
        locationOnMapsLink = `<div><a href="https://www.google.com/maps/search/?api=1&query=${
            results.lat
        },${
            results.lng
        }" target="_blank" rel="noopener noreferrer">${showLocationOnMapsLink}</a></div>`;
    }

    let popoverLength = location.popoverContent ? location.popoverContent.length : 0;
    // Asebling the marker infowindow content.
    for (let i = 0; i < popoverLength; i++) {
        popoverContent += `<div>${location.popoverContent[i]}</div>`;
    }
    // creating the marker
    let marker = new window.google.maps.Marker({
        position: results,
        map: params.map,
        animation: params.markerDropAnimation ? window.google.maps.Animation.DROP : null,
        icon: location.icon || null
    });
    // We are setting a new marker proerty for its infowindow content.
    marker["popoverContent"] = `${popoverContent}${locationOnMapsLink}`;
    marker["id"] = location.id;
    marker["location"] = location.location;

    if (markerActionProps) {
        window.google.maps.event.addListener(marker, "click", function() {
            let toSet = { specificLocation: location.id };

            params.dispatch(triggerSet([widgetId, ...markerActionProps.pathInStore], toSet));
            if (markerActionProps.actions && markerActionProps.actions.length) {
                // we dispatch siren action as well
                dispatchSirenActions(
                    markerActionProps.actions,
                    markerActionProps.widgetId,
                    markerActionProps.computedBindTo
                );
            }
        });
    }

    return marker;
}

// Using the Google Maps API geocoder we convert the human readable address latitude and longitude
// coordinates. This is so we create / place markers on the map using those coordinates.
// The method takes its arguments as an object, because there are several of them and
// to avoid argument misplacement and errors.
export function geoCoding(params) {
    //We return a promise so we know when the callback for the current geolocation has completed.
    return new Promise((resolve, reject) => {
        params.geocoder.geocode(
            //We are making the request to the server sending only the geo location address.
            { address: params.location.location },
            (results, status) => {
                let resolveResponse = {
                    status: status,
                    marker: {}
                };
                if (status === "OK") {
                    // On success we create a marker.
                    let latlng = {
                        lat: results[0].geometry.location.lat(),
                        lng: results[0].geometry.location.lng()
                    };
                    resolveResponse.marker = createMapMarker(latlng, params);
                    // We keep track of the specific marker, this way we know which marker from the,
                    // markers on the map(the array we pass back to the component and from the component,
                    // to the action after we've received new props) is the specific one(if any).
                    if (params.location.specific) {
                        resolveResponse.marker["specific"] = true;
                    }
                    // The request has succeeded so we resolve the promise knowing the
                    // current geolocation converting and marker creation / setting on the map has completed.
                    params.markersReference.push(resolveResponse.marker);
                } else {
                    WEBUILogs.error(params.errorMessages.geoLocationError, status);
                }

                if (status === "OVER_QUERY_LIMIT") {
                    resolveResponse["location"] = params.location;
                }

                resolve(resolveResponse);
            }
        );
    });
}
